import fetcher from "./fetcher";

export function runMigration(password) {
    return fetcher.post(`/dbmigration/${password}`, {});
}
